// English translations
const en = {
  nav: {
    home: "Home",
    projects: "Projects",
    about: "About",
  },
  home: {
    greeting: "Hello, I'm",
    name: "Tommy BOUBAKER",
    role: "Fullstack Developer",
    pitch:
      "I build robust, scalable web applications — from thoughtful APIs to pixel-precise interfaces. Clean code, pragmatic solutions, real results.",
    cta_projects: "View Projects",
    cta_about: "About Me",
    skills_title: "Core Stack",
    featured_title: "Featured Work",
    featured_cta: "View all projects →",
  },
  projects: {
    title: "Projects",
    subtitle: "A selection of things I've built.",
    view_detail: "View details →",
    back: "← Back to projects",
  },
  project_detail: {
    live_link: "Live Demo",
    github_link: "GitHub",
    back: "← Back to projects",
  },
  about: {
    title: "About Me",
    subtitle: "Developer, builder, problem solver.",
    bio_1: `Former baker, passionate about computers since childhood, I decided to pursue a professional reconversion to become a developer.
            A first apprenticeship in self-taught programming languages such as Python and C# allowed me to confirm my interest in programming and to familiarize myself with the basics of development.`,
    bio_2: `I then decided to pursue professional training, following a certified training program with the AFPA Territoire digital to obtain a web and mobile developer degree, and then with Diginamic to obtain an application developer degree. These training programs allowed me to acquire solid skills in web development, while working on concrete projects and using modern technologies.`,
    bio_3:
      "Today, I am confident that I made the right career choice and wish to continue progressing in this field. I strive to write maintainable code, collaborate with good teams, and deliver products that make a difference. Currently open to new opportunities.",
    skills_title: "Skills",
    experience_title: "Experience",
    education_title: "Education",
    download_cv: "Download Resume (PDF)",
    degrees: [
      {
        title: "Professional degree - Application Developper (Bachelor's Degree)",
        institution: "Diginamic - Montpellier",
        period: "2025 – 2026",
      },
      {
        title: "Professional degree - Web and Mobile Developer (Associate's Degree)",
        institution: "AFPA Territoire digital",
        period: "2023 – 2024",
      },
    ],
    exp: [
      {
        role: "Fullstack Developer Intern",
        company: "Plan & Joy",
        period: "December 2025 – March 2026",
        desc: `Collaboration on a multi-purpose application for restaurants (booking, takeaways orders, etc.) and an AI phone receptionnist. 
              Collaboration with Git and Github.
              Back-end development with Node.js.
              Front-end development with Nuxt.js.`,
      },
      {
        role: "Junior Web Developer Intern",
        company: "NOUS - Ouvert, Utile et Simple",
        period: "May 2024 – July 2024",
        desc: `Collaboration on a training management application as part of my web developer training. 
              Version control with Git and Gitlab.
              Front-end development with React.js.
              Back-end development with Symfony.
              Development and maintenance of Wordpress plugins created by the company.`,
      },
    ],
  },
  footer: {
    tagline: "Built with React · Open to work",
    contact: "Get in touch",
  },
  theme: {
    toggle_dark: "Dark mode",
    toggle_light: "Light mode",
  },
};

export default en;
